module.exports = __webpack_public_path__ + "public/SiteImages/schreibtisch.svg?0644ec52";


//////////////////
// WEBPACK FOOTER
// ./public/SiteImages/schreibtisch.svg
// module id = 270
// module chunks = 8